import type { TableQuery } from 'ab-common/dataStructures/tableQuery';

import baseRoute from '../baseRoute';

export type * from './viewModel';
export type * from './queryParams';

type RouteDefinition = `${typeof baseRoute}/${number | ':jobId'}/subjobs/table${`?query=${string}` | ''}`;

export const ROUTE: RouteDefinition = `${baseRoute}/:jobId/subjobs/table`;

/**
 * @param startDate YYYY-MM-DD
 * @param endDate YYYY-MM-DD
 */
export const URL = (jobId: number, tableQuery: TableQuery): RouteDefinition =>
	`${baseRoute}/${jobId}/subjobs/table?query=${encodeURIComponent((JSON.stringify(tableQuery)))}`;
